import * as requests from "../coraWebComponents/utils/requests";

export const login = async (code, redirect_uri, provider) => {
  try {
    let res = await requests.signInOAuth(code, redirect_uri, provider);
    return res;
  } catch (error) {
    throw error;
  }
};

export const register = async (code, redirect_uri, provider) => {
  try {
    let res = await requests.oAuth(code, redirect_uri, provider, "register");
    return res;
  } catch (error) {
    throw error;
  }
};
